import * as types from "./actionTypes";

const initialState = {
  editing: false,
  field: {},
  data: {},
  entity: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.EDITING_TOGGLE:
      return {
        ...state,
        editing: !state.editing,
        entity: action.entity ? action.entity : "",
        field: action.field
      };

    case types.FETCH_EDITS:
      return {
        ...state,
        editing: !state.editing,
        data: action.data,
        id: action.id,
        entity: action.entity
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/editing/reducer.js